
import randomIntBetween from '../../../vendor/scripts/fabrique/modules/random-int-between';
import Component from "../../../assets/scripts/modules/component";

const GRID_X = [
   2, 13, 24,
   2, 13, 24,
   2, 13, 24,
];

const GRID_Y = [
   2,  2,  2,
  13, 13, 13,
  24, 24, 24,
];

const HOURGLASSES = [
  [[0, 0], [2, 0], [0, 2], [2, 2], [0, 0]],
  // [[1, 0], [2, 1], [0, 1], [1, 2], [1, 0]],
  [[2, 0], [2, 2], [0, 0], [0, 2], [2, 0]],
  // [[2, 1], [1, 2], [1, 0], [0, 1], [2, 1]],
  [[2, 2], [0, 2], [2, 0], [0, 0], [2, 2]],
  // [[1, 2], [0, 1], [2, 1], [1, 0], [1, 2]],
  [[0, 2], [0, 0], [2, 2], [2, 0], [0, 2]],
  // [[0, 1], [1, 0], [1, 2], [2, 1], [0, 1]],
];

class Spinner extends Component {

  constructor() {
    super(...arguments);
  }

  init() {
    this.lineContainer = this.element.querySelector('[data-role=lines');
    this.index = 0;
    setInterval(() => {
      this.reset();
      this.drawPath(HOURGLASSES[this.index]);
      this.index = (this.index + 1) % HOURGLASSES.length;
    }, 1500);
  }

  drawPath(items) {
    let path = '';
    items.forEach(item => {
      const [x, y] = item;
      const i = 3 * y + x % 3;
      const [rx, ry] = [GRID_X[i], GRID_Y[i]];
      if (!path.length) {
        path += `M${rx} ${ry}L`;
      } else {
        path += `${rx} ${ry} `;
      }
    });
    const pathEl = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    pathEl.setAttribute('d', path);
    pathEl.setAttribute("class", "draw-stroke");
    pathEl.setAttribute("stroke", "black");
    this.lineContainer.appendChild(pathEl);
  }

  reset() {
    this.lineContainer.innerHTML = '';
  }
}

for (const element of document.querySelectorAll('.spinner')) {
  element.instance = new Spinner('spinner', element, { onLoad: true });
}



// WEBPACK FOOTER //
// ./website/components/atoms/spinner/spinner.js